<template>
	<el-drawer
		 :title="data ? '编辑演出' : '添加演出'"
		:visible.sync="drawerShow"
		:wrapperClosable="false"
		:destroy-on-close="true"
		size="600px"
		@close="close"
	    >        
        <div class="drawer-content">
            <el-form :model="formData" ref="formData" label-position="top" size="medium" :rules="rules">
                <div class="page-filter-box">
                    <el-input placeholder="输入演出ID查询演出" v-model="sActivityIds" :disabled="update">
                        <el-button slot="append" icon="el-icon-search" @click="searchActivity()" :disabled="update">查询演出</el-button>
                    </el-input>
                	<div class="PD10" v-if="formData.activityId">
                		演出ID: {{formData.activityId}}
                		<p class="MT10">演出名称: {{formData.title}}</p>
                	</div>
					<el-form-item class="MT10"  v-if="formData.activityId">
					    <span slot="label">参考数据:</span>
						<table class="info-table"  width="100%">
						    <tr>
						        <th>当前真实售票</th>
						        <th>对外展示售票</th>
								<th>库存总票数</th>
								<th>报批人数</th>
						    </tr>
						    <tr>
						        <td>{{formData.realTicketNum}}</td>
								<td>{{formData.showTicketNum}} （{{formData.ratio}}%）</td>
								<td><span v-if="formData.totalStock && formData.totalStock > 0">{{formData.totalStock}}</span><span v-else>未设置票品库存</span></td>
								<td><span v-if="formData.reportNum">{{formData.reportNum}}</span><span v-else>未设置报批人数</span><span v-if="formData.reportRatio">（{{formData.reportRatio}}%）</span></td>
						    </tr>
						</table>
					</el-form-item>
					<el-form-item class="MT10" >
						<span slot="label">折扣比例:</span>
						<el-slider v-model="formData.ratio" :format-tooltip="formatTooltip" class="slider" :min="1" :max="100" @change="ratioChange()" :disabled="reatioDis"></el-slider> {{formData.ratio}}%
						<small>
							<div>
								报批人数后面的比例为参考比例，最高不能高于参考比例<br>
								比例=100%：<span class="color-danger">此时会将真实售票数</span>展示到看板<br>
								比例<100%：<span class="color-danger">此时会将真实售票数打折后</span>，再展示到看板<br>
								举例：假如设置80%，真实销售票数100，则看板中会看到80
							</div>
						</small>
					</el-form-item>
					<el-form-item prop="pw" label="设置密码:">
					    <el-input v-model="formData.pwd" placeholder="请输入密码" :maxlength="20" style="width: 60%;"></el-input>
						<p class="color-danger">当前密码：{{data ? formData.pwd : '暂未设置'}}</p>
					</el-form-item>
                </div>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading">确 定</el-button>
        </div>
    </el-drawer>
</template>

<script>
const defaultFormData = {
    activityId: '',
	title:'',
	realTicketNum:'',
	showTicketNum:'',
	totalStock:'',
	reportNum:'',
    pwd: '',
    ratio:100
}
export default {
    data() {
        var checkPw = (rule, value, callback) => {
            if (value && value.length < 6) {
                return callback(new Error('至少输入6位'));
            }else{
                callback();
            }
        };
        return {
            drawerShow: false,
            btnLoading: false,
            formData: { ...defaultFormData },
            rules: {
                activityId: [{ required: true, message: "请填写演出ID" }],
                sessionId: [{ required: true, message: "请填写场次ID" }],
                pw: [{ validator: checkPw }]
            },
            data: null,			
			sActivityIds: "",
			sActivityLoading: false,
			update:false,
			reatioDis:false,
			
        }
    },
    methods: {
        show(data) {
			
            this.data = data || null;			
            this.formData = {
                ...defaultFormData,
                activityId: data && data.activityId || "",
				title: data && data.title || "",
				realTicketNum:data && data.realTicketNum || 0,
				showTicketNum:data && data.showTicketNum || 0,
				totalStock:data && data.totalStock || 0,
				reportNum:data && data.reportNum || '',
				reportRatio:data && data.reportRatio || '',
				pwd: data && data.pwd || "",
				ratio:data && parseInt(data.ratio) || 100,
                id:data && data.id || "",
				addTime: data && data.addTime || ""
            }
            if (this.$refs.formData) {
                this.$refs.formData.clearValidate();
            }
            this.drawerShow = true;
			if( data ){
				this.update = true
				
			}else{
				this.update = false
			}
        },
        close() {
            if (this.$refs.formData) {              
                this.$refs.formData.clearValidate();
            }
			this.sActivityIds = ''
            this.drawerShow = false;
        },
		ratioChange(){
			if( this.formData.ratio > this.formData.reportRatio ){
				this.$message.error('折扣比例过高');
				this.formData.ratio = this.formData.reportRatio
				return 
			}
		},
		//搜索演出
		searchActivity() {
			var _sActivityIds = ''
			this.sActivityLoading = true;
			_sActivityIds = this.sActivityIds
			
			if( _sActivityIds == ''){
				this.sActivityLoading = false;
				return this.$message.error('演出ID不能为空');				
			}
			this.$request({
				url: '/gongan/report/sell/info',
				method: 'post',
				params: {activityId:_sActivityIds}
			})
				.then((res) => {
					const { state, msg, result } = res.data;
					if (state == 1) {						
						if ( result ) {					
							
							this.formData = {
								...result,
								ratio: result.reportRatio ? result.reportRatio : 100,
							}
						}else {
							this.$message.error(msg || '没有找到相关演出');
						}						
						
					} else {
						this.$message.error(msg || "没有找到相关演出,请重试");
					}
				})
				.catch(() => {
					this.$message.error("没有找到相关演出,请重试");
				})
				.finally(() => {
					this.sActivityLoading = false;
				});
		},
		formatTooltip(val){
			if (val) {
				return val + "%"
			} 
		},
        submitForm() {			
			if( this.formData.activityId == ''){				
				return this.$message.error('演出不能为空');				
			}
			
			if( !this.formData.pwd ){
				return this.$message.error('请设置密码');				
			}			
            this.$refs["formData"].validate(async (valid) => {
                if (valid) {
                    this.btnLoading = true;					
                    this.$request({
                        url: '/gongan/report/sell/update',
                        data: {
                            ...this.formData
                        },
                        method: "post",
                    })
					.then((res) => {
						const { state, msg } = res.data;
						if (state == 1) {
							this.$emit('onUpdate');
							this.close();
						} else {
							this.$message.error(msg || "操作失败,请重试");
						}
					})
					.catch(() => {
						this.$message.error("操作失败,请重试");
					})
					.finally(() => {
						this.btnLoading = false;
					});
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .info-table{
	font-size: 12px;
	padding: 0;
	line-height: 30px;
	text-align: center;
}
::v-deep .info-table td,::v-deep .info-table th{
    border-right: 1px #E4E7ED solid;
	text-align: center;
}
.slider{
	width: 90%;
	float: left;
	margin-right: 10px;
}
</style>